<template>
  <footer class="min-h-12 bg-primary text-center py-3">
    <a @click="goToLogIn" class="text-blue-600 hover:underline cursor-pointer">
      [ Admin ]
    </a>
  </footer>
</template>

<script>
import { useRouter } from "vue-router";

export default {
  setup() {
    const router = useRouter();
    const goToLogIn = () => router.push("/admin/login");

    return {
      goToLogIn,
    };
  },
};
</script>
